import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotification } from './use-notification';

export const useDeviceConnectionNotification = () => {
  const { create, remove } = useNotification<'device-connection'>();
  useCommonActionSubscriptions('device-connection');

  return {
    create,
    remove,
  };
};
